import React from "react"

import i18n from "@/i18n"

import { type SidebarTimeSlot } from "../reservation_sidebar_availability"

type TimeScrollerProps = {
  slots: SidebarTimeSlot[]
  selectedStartTime: string | null
  onSelect: (startTime: string) => void
}

const TimeScroller: React.FC<TimeScrollerProps> = ({ slots, selectedStartTime, onSelect }) => {
  if (slots.length === 0) {
    return (
      <p className="text-[12px] leading-normal text-[#5f6774]" data-testid="public-venue-mobile-booking-time-empty">
        {i18n.t("app.public.venue.sidebar.time_unavailable")}
      </p>
    )
  }

  return (
    <div
      className="-mx-5 flex gap-2 overflow-x-auto px-5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      data-testid="public-venue-mobile-booking-time-scroller"
    >
      {slots.map((slot) => {
        const isSelected = selectedStartTime === slot.startTime

        return (
          <button
            key={slot.startTime}
            type="button"
            onClick={() => onSelect(slot.startTime)}
            aria-pressed={isSelected}
            data-selected={isSelected}
            data-testid={`public-venue-mobile-booking-time-option-${slot.label}`}
            className={`flex h-[36px] shrink-0 items-center justify-center rounded-[6px] border-[0.5px] px-[16px] text-[14px] leading-normal transition-colors ${
              isSelected
                ? "border-[#2176c1] bg-[#2596fa] font-medium text-white"
                : "border-[#e5e6ec] bg-white font-normal text-[#374151]"
            }`}
          >
            {slot.label}
          </button>
        )
      })}
    </div>
  )
}

export default TimeScroller
